import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./MainView.css";

import { LoadingSpinner } from "Projects/CC_cubi_clan_project/GlobalComponents/LoadingSpinner/LoadingSpinner";
import { NavMenu } from "Projects/CC_cubi_clan_project/GlobalComponents/NavMenu/NavMenu";
import { consumeReturnPath } from "Projects/CC_cubi_clan_project/Utils/AuthNavigation";
import { restoreSession } from "Projects/CC_cubi_clan_project/Utils/SessionManager";

export default function MainView() {
  const [isLoading, setLoading] = useState(false);
  const [sessionStatus, setSessionStatus] = useState("checking");
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    restoreSession(undefined, { force: true })
      .then((profile) => {
        if (!active) return;
        if (profile) navigate(consumeReturnPath() || "/home", { replace: true });
        else setSessionStatus("anonymous");
      })
      .catch(() => active && setSessionStatus("network-error"));
    return () => { active = false; };
  }, [navigate]);

  const handleAuthentication = (isLoggedIn) => {
    if (isLoggedIn) navigate(consumeReturnPath() || "/home", { replace: true });
  };

  if (sessionStatus === "checking") return null;
  if (sessionStatus === "network-error") {
    return <div role="status">No se pudo verificar la sesión. Revisa la conexión e inténtalo de nuevo.</div>;
  }

  return (
    <div>
      <LoadingSpinner isLoading={isLoading} />
      <NavMenu
        title="Cuberite"
        onLoggedIn={handleAuthentication}
        onLoading={setLoading}
        isLoggedIn={false}
        sessionManaged
      ></NavMenu>
    </div>
  );
}
